import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { CustomerAccountItem } from '@inyova/models';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
export class DeepLinksService {
  protected readonly onDestroy$ = new Subject<void>();

  constructor(private store: Store) {}

  getSelectedAccountFromURL(event: NavigationEnd): void {
    this.store
      .select(fromAppRoot.selectCustomer)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        const url = new URL(event.urlAfterRedirects, window.location.origin);
        const accountType = url.searchParams.get('account');
        if (!accountType) return;

        const preferedAccount = this.selectPreferedAccount(value.temporary_accounts, accountType);
        if (preferedAccount && preferedAccount.id) {
          this.store.dispatch(AppRootActions.switchAccount({ id: preferedAccount.id, redirectUrl: null }));
        }
        this.onDestroy$.next();
      });
  }

  private selectPreferedAccount(accounts: CustomerAccountItem[], preferedAccountKind: string): CustomerAccountItem {
    return accounts.find((item) => item.kind === preferedAccountKind);
  }
}
